import React from 'react';
import { Title as Title$1 } from '@10d/tend-ui-typography';

const Title = (props) => {
    return React.createElement(Title$1, Object.assign({ level: 'h3', mt: 0 }, props));
};
Title.displayName = 'Layout.Title';

export { Title };
